export default __webpack_public_path__ + "static/icons-157e57dfcd00dcbf3104b438497b1d36.svg";